export default "__VITE_ASSET__uwVWjFJy__"